import React from 'react'

type Props = {
  level: number
  width?: number
  wellBg?: string
  wellStroke?: string
  fillColor?: string
  gap?: number
}

export default function BatteryIcon({
  level,
  width = 27,
  wellBg = '#F4EDDB',
  wellStroke = '#9B978A',
  fillColor = '#000000',
  gap = 1.2
}: Props) {
  const pct = Math.max(0, Math.min(100, level))
  const vbW = 27
  const vbH = 12

  const innerX = 2
  const innerY = 2
  const innerW = 20
  const innerH = 8
  const innerRx = 1.5

  const fillW = Math.max(0, (innerW - gap * 2) * (pct / 100))
  const fillX = innerX + gap
  const fillY = innerY + gap
  const fillH = innerH - gap * 2
  const fillRx = Math.min(fillH / 2, innerRx)

  const h = (width * vbH) / vbW

  return (
    <svg width={width} height={h} viewBox={`0 0 ${vbW} ${vbH}`} xmlns="http://www.w3.org/2000/svg">
      <path
        d="M18.7998 0C20.62 0 21.5304 0.000263363 22.2256 0.354492C22.837 0.666053 23.3339 1.16304 23.6455 1.77441C23.9997 2.46963 24 3.38002 24 5.2002V6.7998C24 8.61998 23.9997 9.53037 23.6455 10.2256L23.5205 10.4492C23.2083 10.9583 22.7606 11.3728 22.2256 11.6455L22.0928 11.708C21.4132 12 20.5065 12 18.7998 12H5.2002L3.99512 11.9941C2.93841 11.9775 2.2959 11.9112 1.77441 11.6455C1.23938 11.3728 0.791722 10.9583 0.479492 10.4492L0.354492 10.2256C0.000263363 9.53037 0 8.61998 0 6.7998V5.2002C0 3.49351 -2.64886e-05 2.58675 0.291992 1.90723L0.354492 1.77441C0.627155 1.23938 1.04169 0.791722 1.55078 0.479492L1.77441 0.354492C2.2959 0.0887819 2.93841 0.0224518 3.99512 0.00585938L5.2002 0H18.7998ZM25 4.06348C25.8626 4.28554 26.5 5.06812 26.5 6C26.5 6.93188 25.8626 7.71446 25 7.93652V4.06348Z"
        fill={wellStroke}
      />

      <rect
        x={innerX}
        y={innerY}
        width={innerW}
        height={innerH}
        rx={innerRx}
        fill={wellBg}
        stroke={wellStroke}
        strokeWidth="0.7"
      />

      <clipPath id="battery-well-clip">
        <rect x={innerX} y={innerY} width={innerW} height={innerH} rx={innerRx} />
      </clipPath>

      <g clipPath="url(#battery-well-clip)">
        <rect
          x={fillX}
          y={fillY}
          width={fillW}
          height={fillH}
          rx={fillRx}
          fill={fillColor}
        />
      </g>
    </svg>
  )
}
